// Mantenha a lista e o tamanho em sincronia com ChatController.php.
export const ALLOWED_EXTENSIONS = [
    'doc', 'docx', 'xls', 'xlsx', 'pdf', 'png', 'jpg', 'jpeg',
];

export const MAX_ATTACHMENT_BYTES = 10 * 1024 * 1024;
export const ATTACHMENT_ACCEPT = ALLOWED_EXTENSIONS.map((extension) => `.${extension}`).join(',');

// Segue a mesma base usada no Conversation.vue original e o axios já configurado no projeto.
export const CHAT_CONVERSATION_URL = 'api/dashboard/chat/conversation';

export function formatFileSize(size) {
    const bytes = Number(size);

    if (!Number.isFinite(bytes) || bytes < 0) {
        return '';
    }

    if (bytes < 1024) {
        return `${bytes} B`;
    }

    if (bytes < 1024 * 1024) {
        return `${(bytes / 1024).toFixed(1)} KB`;
    }

    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function validateAttachment(file) {
    if (!file) {
        return '';
    }

    const name = String(file.name || '');
    const dot = name.lastIndexOf('.');
    const extension = dot >= 0 ? name.slice(dot + 1).toLowerCase() : '';

    if (ALLOWED_EXTENSIONS.indexOf(extension) === -1) {
        return 'Formato não permitido. Envie DOC, DOCX, XLS, XLSX, PDF, PNG, JPG ou JPEG.';
    }

    if (!Number.isFinite(file.size) || file.size <= 0) {
        return 'O arquivo selecionado está vazio ou é inválido.';
    }

    if (file.size > MAX_ATTACHMENT_BYTES) {
        return 'O anexo deve ter no máximo 10 MB.';
    }

    return '';
}

export function requestErrorMessage(error) {
    const response = error && error.response;

    if (!response) {
        return 'Não foi possível concluir a operação. Verifique sua conexão e tente novamente.';
    }

    if (response.status === 413) {
        return 'O arquivo excedeu o limite de envio do servidor.';
    }

    if (response.status === 401) {
        return 'Sua sessão expirou. Entre novamente no sistema.';
    }

    if (response.status === 403) {
        return 'Você não tem permissão para acessar esta conversa ou este anexo.';
    }

    if (response.status === 404) {
        return 'A conversa ou o anexo não foi encontrado.';
    }

    const data = response.data;

    if (data && data.errors) {
        const fields = Object.keys(data.errors);

        if (fields.length) {
            const errors = data.errors[fields[0]];
            return Array.isArray(errors) ? errors.join(' ') : String(errors);
        }
    }

    if (data && typeof data.message === 'string' && response.status < 500) {
        return data.message;
    }

    return 'Não foi possível concluir a operação. Tente novamente.';
}
